/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";
import { Icon, ICON_SIZE } from "../Icon";

/**
 * Component props
 */
export interface IDialogHeaderProps {
	title: string;
	icon?: string;
	onClose?: () => void;
}

/**
 * Dialog Panel
 * Displays base dialog box.
 * @param props Component props
 */
export const DialogHeader: FC<IDialogHeaderProps> = ({ title, icon, onClose, children }) => {
	const baseClass = BEM("edt-dialog", "header");

	return (
		<div className={baseClass.toClassName()}>
			{icon ? (
				<Icon
					name={icon}
					size={ICON_SIZE.SMALL}
					className={baseClass.element("header-icon").toClassName()}
				/>
			) : null}
			<span className={baseClass.element("header-title").toClassName()}>{title}</span>
			{children}
			{onClose ? (
				<button
					className={baseClass.element("close-btn").toClassName()}
					onClick={onClose}
					type="button"
				>
					<Icon name="mdi/close" size={ICON_SIZE.SMALL} />
				</button>
			) : null}
		</div>
	);
};
